import { c as _c } from "react/compiler-runtime";
import { formatDate, getTimezoneAbbreviation } from '../../utils/date';
import { useDatePreferences } from '../hooks/useDatePreferences';
import Text from './base/Text';
import type { StyledUtilsProps } from './helpers/StyledUtils';
interface DisplayDateProps extends StyledUtilsProps {
  date: string | null;
  empty_string?: string;
  size?: 'xs' | 's' | 'm';
  show_timezone?: boolean;
}
const DisplayDate: React.FC<DisplayDateProps> = t0 => {
  const $ = _c(16);
  let date;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      date,
      empty_string: t1,
      size: t2,
      show_timezone: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = date;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    date = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const empty_string = t1 === undefined ? "\u2013" : t1;
  const size = t2 === undefined ? "s" : t2;
  const show_timezone = t3 === undefined ? true : t3;
  const {
    timezone
  } = useDatePreferences();
  let t4;
  if ($[6] !== date || $[7] !== empty_string || $[8] !== show_timezone || $[9] !== timezone) {
    t4 = date ? `${formatDate(date, "yyyy-MM-dd HH:mm:ss", timezone)} ${show_timezone ? getTimezoneAbbreviation(timezone, date) : ""}` : empty_string;
    $[6] = date;
    $[7] = empty_string;
    $[8] = show_timezone;
    $[9] = timezone;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const text_date = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      b: 0
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== props || $[13] !== size || $[14] !== text_date) {
    t6 = <Text mono={true} size={size} muted={true} as="p" m={t5} ellipsis={true} title={text_date} {...props}>{text_date}</Text>;
    $[12] = props;
    $[13] = size;
    $[14] = text_date;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default DisplayDate;